module.exports = __webpack_public_path__ + "img/logo-tatarana.c3a40492.svg";